<template>
  <div class="m-slugs"
       :class="{ '--transition': transition }">
    <div class="m-slugs__wrapper">
      <div class="m-slugs__activelist" :style="activeStyle">
        <div v-on:click="goSlug()" class="m-slugs__slug --active">
          {{ currentDisplayed | ellipse }}
        </div><!--
      --><span v-on:click="goSlug()" class="m-slugs__slug --close"
               v-show="currentDisplayed !== general.name">
          <img :src="srcImgClose" alt="">
        </span><!--
      --><div class="m-slugs__slugsearch"
              v-on:click="openSearch()">
        <img :src="srcImgLoupe" alt="">
      </div>
      </div>
      <div class="m-slugs__sluglist">
        <div v-for="i in [0, 1, 2]"
             v-bind:key="i"
             v-on:click="goSlug(displayed[i])"
             v-bind:class="{
               '--deploy': slugs[i] && !displayed[i],
               '--switch': slugs[i] && displayed[i] && slugs[i] !== displayed[i],
               '--active': slugs[i] && displayed[i],
             }"
             class="m-slugs__slug --list">
          <div class="m-slugs__slugwrapper">
            <span class="m-slugs__content">{{ displayed[i] | ellipse }}</span><br>
            <span class="m-slugs__next">{{ slugs[i] | ellipse }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="m-slugs__modalsearch"
       ref="modalsearch"
       v-bind:class="{ '--open': openModal }">
      <span  class="a-modalearch__close" v-on:click="closeSearch()">
        <img :src="srcImgCloseDark" alt="">
      </span>
      <div class="a-modalearch__content">
        <p>
          <span ref="modaltexte">entre un sujet pour explorer<br>un nouveau fil d'actualité</span>
        </p>
        <form action="javascript:void(0);">
          <div class="a-modalearch__input" ref="modalinput">
            <input type="text" ref="modalfocus" id="input" autocomplete="off" v-bind:style="{
              color: startColor,
            }">
            <div class="a-modalearch__underline" v-bind:style="{
              'background-color': startColor,
            }"></div>
          </div>
          <div class="a-modalearch__submit" ref="modalcsubmit">
            <button type="submit" ref="modalsubmit"
            v-on:click="validation">ok</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { TimelineLite, Power2 } from 'gsap';
import ToggleBtn from './Channels/ToggleBtn';
import srcImgClose from '../../assets/images/close-mots.svg';
import srcImgCloseDark from '../../assets/images/cross.png';
import srcImgLoupe from '../../assets/images/loupe.png';

export default {
  name: 'viewer',
  data() {
    return {
      displayed: [],
      transition: undefined,
      currentDisplayed: '',
      openModal: false,
      srcImgClose,
      srcImgLoupe,
      srcImgCloseDark,
      timeline: null,
    };
  },
  components: {
    ToggleBtn,
  },
  filters: {
    ellipse(name = '') {
      return name.substring(0, 9) + (name.length > 10 ? '.' : name.substring(9, 10));
    },
  },
  computed: {
    ...mapGetters([
      'general',
      'loading',
      'sequences',
      'currentSequence',
      'displayedSequence',
      'displayedName',
      'currentSlug',
      'startColor',
    ]),
    activeStyle() {
      return {
        'background-color': this.startColor,
        // border: `1px solid ${this.startColor}`,
        color: 'white',
      };
    },
    slugs() {
      if (this.displayedSequence && this.displayedSequence.slugs) {
        return this.displayedSequence.slugs
          .filter(s => s !== this.currentSlug)
          .slice(0, 3);
      }
      return [];
    },
  },
  methods: {
    ...mapMutations([
      'setCurrentSlug',
      'play',
      'pause',
    ]),
    ...mapActions([
      'getChannelById',
      'updateSlug',
    ]),
    goSlug(slug) {
      if (slug !== this.currentSlug) this.updateSlug(slug);
      if (!slug) this.$router.push(`/c/${this.general.id}`);
    },
    openSearch() {
      if (this.timeline === null) {
        this.timeline = new TimelineLite({
          pause: true,
          autoRemoveChildren: true,
          useFrames: false,
        });
      }
      this.openModal = true;
      this.timeline.to(this.$refs.modalinput, 0.5, {
        minWidth: '640px',
        bottom: 0,
        ease: Power2.easeOut,
      });
      this.timeline.to(this.$refs.modaltexte, 0.8, {
        bottom: 0,
        ease: Power2.easeOut,
      }, '-=0.3');
      this.timeline.to(this.$refs.modalsubmit, 0.8, {
        bottom: 0,
        width: '100%',
        ease: Power2.easeOut,
      }, '-=0.4');
      this.$refs.modalfocus.focus();
      this.pause();
    },
    closeSearch() {
      this.timeline.to(this.$refs.modalsubmit, 0.6, {
        bottom: -100,
        ease: Power2.easeIn,
      });
      this.timeline.to(this.$refs.modaltexte, 0.3, {
        opacity: 0,
        ease: Power2.easeIn,
        onComplete: () => {
          this.openModal = false;
          this.goSlug(this.$refs.modalfocus.value);
          this.timeline.set(this.$refs.modalsubmit, { clearProps: 'all' });
          this.timeline.set(this.$refs.modaltexte, { clearProps: 'all' });
          this.timeline.set(this.$refs.modalinput, { clearProps: 'all' });
          this.$refs.modalfocus.value = '';
        },
      });
    },
    validation() {
      if (this.$refs.modalfocus.value.length <= 25) {
        const val = this.$refs.modalfocus.value;
        this.closeSearch();
        clearTimeout(this.transition);
        this.transition = setTimeout(() => {
          this.goSlug(val);
          this.transition = clearTimeout(this.transition);
        }, 800);
      } else {
        // TODO MESSAGE ERREUR
      }
    },
    update() {
      this.displayed = this.displayedSequence ? this.slugs : [];
    },
  },
  watch: {
    sequences() {
      this.currentDisplayed = this.displayedName;
      this.displayed = [];
    },
    displayedSequence() {
      clearTimeout(this.transition);

      this.transition = setTimeout(() => {
        this.update();
        this.transition = clearTimeout(this.transition);
      }, 1700);
    },
  },
  mounted() {
    this.update();
  },
};
</script>

<style lang="scss" scoped>
  .m-slugs {
    transition: 1s all;
    cursor: pointer;

    &__wrapper {
      font-size: 14px;
      line-height: 20px;
    }
    &__close {
      padding-left: 20px;
    }
    &__sluglist {
      &:before {
        display: inline-block;
        content: ' ';
        width: 1px;
        padding: 10px 0;
        vertical-align: middle;
        background-color: #484848;
        height: 14px;
        right: -1px;
        position: relative;
        top: -1px;
      }
    }
    &__activelist {
      color: black;
      transition: background-color 0.4s;
      display: inline-block;
      background-color: black;
    }
    &__slugwrapper {
      position: relative;
      top: 0;
    }
    &__slug {
      display: inline-block;
      padding: 5px 0;
      border: 1px solid transparent;
      text-align: center;
      font-family: TrioGrotesk, sans-serif;
      text-transform: uppercase;
      opacity: 0;
      width: 0;
      background-color: transparent;
      vertical-align: bottom;
      transition: background-color 1s, width 1s, opacity 0s linear 1s;
      border-right: 0px;
      height: 24px;
      line-height: 27px;

      .m-slugs__content {
        opacity: 0;
        transition: opacity 0.25s;
      }

      &:not(:first-child) {
        border-left: 0;
      }

      &.--list {
        border: 1px solid #484848;
        background-color: white;
        border-left: 0px;
        color: #484848;
        overflow: hidden;
      }

      &.--close {
        width: auto;
        //padding-left: 15px;
        padding-right: 15px;
        opacity: 1;
        img {
          height: 11px;
          position: relative;
          top: 1px;
        }
      }

      &.--deploy {
        opacity: 1;
        transition-delay: 0.75s;
        width: 11em;
        transition: background-color 1s, width 0.5s ease-out, opacity 0s;
        &:nth-child(2) {
          transition: background-color 1s, width 0.5s ease-out 0.5s, opacity 0s;
        }
        &:nth-child(3) {
          transition: background-color 1s, width 0.5s ease-out 1s, opacity 0s;
        }
        .m-slugs__content {
          opacity: 1;
        }

        .m-slugs__slugwrapper {
          top: -1.95em;
          transition: 1s top;
          transition-delay: 0.8s;
        }
        &:nth-child(2) .m-slugs__slugwrapper {
          transition-delay: 1s;
        }
        &:nth-child(3) .m-slugs__slugwrapper {
          transition-delay: 1.2s;
        }
      }

      &.--active {
        opacity: 1;
        width: 11em;

        .m-slugs__content {
          opacity: 1;
        }
      }

      &.--switch {
        .m-slugs__slugwrapper {
          top: -1.95em;
          transition: 1s top;
        }
        &:nth-child(2) .m-slugs__slugwrapper {
          transition-delay: 0.2s;
        }
        &:nth-child(3) .m-slugs__slugwrapper {
          transition-delay: 0.4s;
        }
      }
    }
    &__slugsearch {
      display: inline-block;
      border-left: 0px;
      border-bottom: 0px;
      text-align: center;
      font-family: TrioGrotesk, sans-serif;
      text-transform: uppercase;
      opacity: 1;
      width: 37px;
      background-color: transparent;
      height: 34px;
      border-left: 1px solid white;
      border-top: 1px solid transparent;
      border-bottom: 1px solid transparent;
      border-right: 1px solid transparent;

      img {
        width: 15px;
        position: relative;
        top: 9px;
      }
    }
    &__modalsearch {
      display: none;
      position: fixed;
      width: 100vw;
      height: 100vh;
      top: 0;
      left: 0;
      background: #fff;
      z-index: 2;
      &.--open {
        display: block;
      }
    }
    .a-modalearch {
      &__close {
        position: fixed;
        right: 20px;
        top: 20px;
      }
      &__content {
       position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        p {
          text-transform: uppercase;
          font-family: 'TrioGrotesk';
          font-size: 17px;
          text-align: center;
          line-height: 28px;
          overflow: hidden;
          position: absolute;
          top: -170px;
          left: 50%;
          transform: translateX(-50%);
          width: 600px;

          span {
            position: relative;
            bottom: -100px;
          }
        }
        input {
          font-family: 'TrioGrotesk';
          color: #406EB9;
          border: 0px;
          -webkit-appearance: none;
          width: 100%;
          outline: none;
          font-size: 100px;
          padding-bottom: 10px;
          text-align: center;
          text-transform: uppercase;
        }
        button {
          font-family: 'TrioGrotesk';
          text-transform: uppercase;
          font-size: 17px;
          -webkit-appearance: none;
          background-color: transparent;
          margin: 0 auto;
          display: inherit;
          padding: 0;
          width: 0;
          position: relative;
          bottom: -100px;
          border: 0px;

          &:focus {
            outline: none;
          }
        }
      }
      &__underline {
        content: '';
        width: 100%;
        height: 8px;
        background-color: #406EB9;
        display: block;
        margin-bottom: 20px;
        border-radius: 5px;
      }
      &__input {
        width: 10px;
        margin: 0 auto;
        position: relative;
        bottom: -100px;
      }
      &__submit {
        width: 0px;
        margin: 0 auto;
        position: relative;
        bottom: -100px;
        display: table;
        overflow: hidden;
        padding-bottom: 3px;
        &:after {
          content: '';
          width: 100%;
          height: 1px;
          background-color: #000;
          display: block;
          position: relative;
          bottom: -3px;
        }
      }
      &__close {
        img {
          position: relative;
          top: 20px;
          right: 20px;
          width: 25px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Player/Slugs.vue